'use strict'

function ValidationError (errors) {
  this.name = 'ValidationError'
  this.errors = errors
}

ValidationError.prototype = Error.prototype

module.exports = ValidationError



//////////////////
// WEBPACK FOOTER
// ./node_modules/har-validator/lib/error.js
// module id = uunQ
// module chunks = 0